import { useTopic } from 'hooks/useTopic';
import { FC } from 'react';
import { Answer, Task } from 'types/elearning';
import { Question } from '..';

interface IProps {
    task: Task;
    isChecked: boolean;
    correctAnswer: Answer['correct_answer'];
    isQuiz: boolean;
    prefix?: string;
}

export const QuestionsSingle: FC<IProps> = ({
    task,
    isChecked,
    correctAnswer,
    isQuiz,
    prefix
}) => {
    const { checkedAnswers, handleSetCheckedAnswersSingle, handleSetLearningAnswersSingle, useLearningAnswersByTask } = useTopic();
    
    return (
        <>
            {task?.content &&
                Object?.entries?.(task?.content)?.map?.(
                    ([questionId, question], id) => (
                        <div className='question_container' key={`task-${task.id}-${id}`}>
                            <Question
                                title={question?.scenarioText ? question?.scenarioText : question?.question}
                                answers={question?.answers}
                                checkedAnswers={isQuiz ? checkedAnswers?.[questionId] : useLearningAnswersByTask(task.id)[questionId]}
                                correctAnswers={correctAnswer?.[questionId]}
                                isChecked={isChecked}
                                prefix={isQuiz ? id + 1 : prefix}
                                description={question?.scenarioText ? question?.question : undefined}
                                setAnswers={(newAnswerId) => {
                                    isQuiz 
                                    ? 
                                        handleSetCheckedAnswersSingle(
                                            questionId,
                                            newAnswerId
                                        )
                                    :
                                        handleSetLearningAnswersSingle(
                                            task.id,
                                            questionId,
                                            newAnswerId
                                        )
                                    }
                                }
                                isQuiz={isQuiz}
                            />
                        </div>
                    )
                )}
        </>
    );
};
